import { FC, useState } from 'react';

import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { INoContractSectionProps } from './types';
import { NoContractSectionHeader } from './SectionHeader';

const StyledAccordion = styled(MuiAccordion)({
  borderRadius: '8px!important',
  boxShadow: 'none',
  border: 'none',
});

const StyledAccordionSummary = styled(AccordionSummary)({
  padding: '12px 0',
  fontSize: '14px',
  lineHeight: '24px',
  fontWeight: 'bold',
  color: '#606060',
  backgroundColor: 'transparent',
  borderRadius: '0!important',

  '&.Mui-expanded': {
    margin: 0,
    minHeight: 0,
    borderRadius: '8px 8px 0 0!important',
  },

  '& .MuiAccordionSummary-content': {
    margin: 0,
    padding: 0,
    border: 'none',
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 'bold',
    color: '#606060',

    '&.Mui-expanded': {
      margin: 0,
      minHeight: 0,
    },
  },

  '& .MuiAccordionSummary-expandIconWrapper': {
    transform: 'rotate(270deg)',

    '&.Mui-expanded': {
      transform: 'rotate(0deg)',
    },

    '& .MuiSvgIcon-root': {
      color: '#606060',
    },
  },
});

const StyledAccordionDetails = styled(AccordionDetails)({
  padding: '0',
});

export const NoContractSection: FC<INoContractSectionProps> = (props) => {
  const { title, description, children } = props;
  const [isExpanded, setIsExpanded] = useState<boolean>(true);

  return (
    <div className='relative mb-24 last:mb-0'>
      <StyledAccordion expanded={isExpanded} onChange={() => setIsExpanded(!isExpanded)}>
        <NoContractSectionHeader title={title} description={description}>
          <StyledAccordionSummary expandIcon={<ExpandMoreIcon sx={{ fontSize: '1.8rem', color: '#ffffff' }} />} />
        </NoContractSectionHeader>

        <StyledAccordionDetails>
          <div className='mt-24'>{children}</div>
        </StyledAccordionDetails>
      </StyledAccordion>
    </div>
  );
};
